import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Modal } from "antd";
import axios from "axios";
import MainButtonComp from "../Buttons/MainButtonComp";
import { generalErrorAlert } from "../GeneralErrorAlert";
import { isAuthenticated } from "../Auth/auth";
import { Error, Success } from "../Messages/Messages";
import { useTranslation } from "react-i18next";

export const CreateNewInventory = ({ projectId, milestoneId, updateParent }) => {
  const { t } = useTranslation("dashboard");
  let serviceProviderId = isAuthenticated()?.employer?._id
    ? isAuthenticated()?.employer?._id
    : isAuthenticated()?.serviceProviderId;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = async values => {
    try {
      setLoading(true);
      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/inventory/add`,
          {
            ...values,
            projectId,
            milestoneId,
            serviceProvider: serviceProviderId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          setLoading(false);
          if (res.status === 200 || res.status === 304) {
            Success(res.data.successMessage);
            handleCancel();
            form.resetFields();
            updateParent();
          } else {
            Error(res.data.errorMessage);
          }
        })
        .catch(err => {
          setLoading(false);
          generalErrorAlert(err);
        });
    } catch (error) {
      setLoading(false);
      generalErrorAlert(error);
    }
  };

  return (
    <>
      <MainButtonComp text="Add Inventory" addBtn onClick={showModal} />
      <Modal
        width={600}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" loading={loading} type="primary" onClick={() => form.submit()}>
            {t("Add Item")}
          </Button>
        ]}
        title={t("Add Item")}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" className="mt-3">
          <Form.Item
            label={t("Item Name")}
            name="itemName"
            rules={[{ required: true, message: t("enter", { field: t("item name") }) }]}
          >
            <Input placeholder={t("enter", { field: t("item name") })} />
          </Form.Item>
          <Form.Item
            label={t("Total Quantity")}
            name="total"
            rules={[{ required: true, message: t("enter", { field: t("total quantity") }) }]}
          >
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              placeholder={t("enter", { field: t("total quantity") })}
            />
          </Form.Item>
          <Form.Item label={t("Minimum quantity to notify")} name="minimumAmount">
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              placeholder={t("enter", { field: t("minimum quantity") })}
            />
          </Form.Item>
          <Form.Item label={t("Notes")} name="notes">
            <Input.TextArea rows={4} placeholder={t("Add any additional notes")} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
